import { render, staticRenderFns } from "./PicComp.vue?vue&type=template&id=4ca4297c&scoped=true"
import script from "./PicComp.vue?vue&type=script&lang=js"
export * from "./PicComp.vue?vue&type=script&lang=js"
import style0 from "./PicComp.vue?vue&type=style&index=0&id=4ca4297c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca4297c",
  null
  
)

export default component.exports